// See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
export enum KeyIds {
  ENTER = "Enter",
  TAB = "Tab",
  SPACE = " ",
  LEFT = "ArrowLeft",
  UP = "ArrowUp",
  RIGHT = "ArrowRight",
  DOWN = "ArrowDown",
  ESCAPE = "Escape"
}
